<template>
    <div class="media-box">
        <div class="size-controller">
            <button type="button" id="screen-fit" :class="{on: fitMode=='screen'}" @click="fitMode='screen'"><span>화면맞춤</span></button>
            <button type="button" id="width-fit" :class="{on: fitMode=='width'}" @click="fitMode='width'"><span>폭맞춤</span></button>
            <button type="button" id="origin-fit" :class="{on: fitMode=='origin'}" @click="fitMode='origin'"><span>원본크기</span></button>
        </div>
        <div
            class="size-cover width"
            :class="{
                'screen-fit': fitMode=='screen', 'width': fitMode=='screen',
                'width-fit': fitMode=='width', 'center': fitMode=='width',
                'origin-fit': fitMode=='origin', 
            }"
        >
            <img :src="mainUrl" alt="이미지" @error="replaceByDefault">
        </div>
    </div>
</template>

<script>
export default {
    props: {
        mainUrl: { type: String }, // 이미지 주소 (풀사이즈)
        subUrl: { type: String }, // 보조 이미지 주소 (미디엄사이즈)
    },
    data() {
        return {
            fitMode: 'screen', // 보기 모드
        }
    },
    created(){
        this.retryCount = 0;
    },
    methods: {
        // 풀사이즈 로드 실패시하면 미디엄 사이즈 시도
        replaceByDefault(event){
            if(this.retryCount<1) event.target.src = this.subUrl; 
            this.retryCount++;
        }
    }
}
</script>